import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Debounce } from 'react-throttle';
import WindowResizeListener from 'react-window-size-listener';
import { IntlProvider } from 'react-intl';
import AppRouter from './appRouter';
import Sidebar from '../Sidebar';
import Topbar from '../TopbarNoAuth';
import AppLocale from '../../languageProvider';
import authAction from '../../redux/auth/actions';
import appActions from '../../redux/app/actions';
import themeActions from '../../redux/themeSwitcher/actions';
import MUIPProvider from '../../components/uielements/materialUiPicker/momentProvider';
import { rtl } from '../../settings/withDirection';
import Main, { Root, AppFrame } from './style';
import './global.css';

const { toggleAll, changeBredHeight } = appActions;
const { switchActivation } = themeActions;

class AppNoAuth extends Component {

	componentDidUpdate(prevProps) {
		if (this.props.location !== prevProps.location) {
			this.props.changeBredHeight();
		}
	}

	render() {
		const anchor = rtl === 'rtl' ? 'right' : 'left';
		const {
			classes,
			theme,
			toggleAll,
			locale,
			match,
			scrollHeight,
			bredHeight,
			fixedNavbar,
			view
		} = this.props;
		const { url } = match;
		const options = { url, classes, theme, locale };
		const currentAppLocale = AppLocale[locale];
		return (
			<IntlProvider
				locale={currentAppLocale.locale}
				messages={currentAppLocale.messages}
			>
				<Root>
					<Debounce time="1000" handler="onResize">
						<WindowResizeListener
							onResize={windowSize =>
								toggleAll(windowSize.windowWidth, windowSize.windowHeight)
							}
						/>
					</Debounce>
					<AppFrame>
						<Topbar {...options} />
						<Main>
							<MUIPProvider>
								<AppRouter
									style={{ marginTop: bredHeight, height: scrollHeight, overflowY: 'auto' }}
									url={url}
									{...options}
								/>
							</MUIPProvider>
						</Main>
					</AppFrame>
				</Root>
			</IntlProvider>
		);
	}
}

const mapStateToProps = state => {
	return {
		auth: state.Auth,
		locale: state.LanguageSwitcher.language.locale,
		scrollHeight: state.App.scrollHeight, // toJs()
		bredHeight: state.App.bredHeight,
		fixedNavbar: state.App.fixedNavbar,
		view: state.App.view,
	};
};
const appConect = connect(
	mapStateToProps,
	{
		toggleAll,
		switchActivation,
		changeBredHeight
	}
)(AppNoAuth);

export default appConect;



// WEBPACK FOOTER //
// ./src/containers/AppNoAuth/index.js